import { z } from 'zod';
import { BibleLocationSchema } from '../bible/bible-location.js';
import { StudySceneSchema } from './study-scene.js';
import { StudentAssignmentSchema } from './student-assignment.js';
import { TeacherAssignmentSchema } from './teacher.js';
/**
 * AI-generated pericope commentary attached to a study. Optional — a study
 * prints fine without it; when present it renders as the last PDF page.
 */
export const StudyAiCommentarySchema = z.object({
    pericopeTitle: z.string(),
    reference: z.string(),
    text: z.string(),
    generatedAt: z.string(),
});
/**
 * Study schema - a complete Bible study session
 */
export const StudySchema = z.object({
    id: z.string(),
    name: z.string().min(1),
    createdAt: z.string(),
    updatedAt: z.string(),
    startingLocation: BibleLocationSchema,
    endingLocation: BibleLocationSchema.optional(),
    studyGroupId: z.string(),
    scenes: z.array(StudySceneSchema),
    writingLocation: BibleLocationSchema,
    memoryStartingLocation: BibleLocationSchema.optional(),
    memoryEndingLocation: BibleLocationSchema.optional(),
    assignments: z.array(StudentAssignmentSchema),
    teacherAssignments: z.array(TeacherAssignmentSchema).default([]),
    aiCommentary: StudyAiCommentarySchema.optional(),
    /** Experimental — the reader's "Any thoughts?" notes on the passage.
     *  Entered in the study editor (or captured when generating commentary
     *  from the chat card); seeds AI commentary generation, prints on the
     *  teacher pages, and renders in the markdown twin. */
    readerThoughts: z.string().optional(),
});
/**
 * Working study - a study in progress (all fields optional)
 */
export const WorkingStudySchema = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    startingLocation: BibleLocationSchema.optional(),
    endingLocation: BibleLocationSchema.optional(),
    studyGroupId: z.string().optional(),
    scenes: z.array(StudySceneSchema).optional(),
    writingLocation: BibleLocationSchema.optional(),
    memoryStartingLocation: BibleLocationSchema.optional(),
    memoryEndingLocation: BibleLocationSchema.optional(),
    assignments: z.array(StudentAssignmentSchema).optional(),
    teacherAssignments: z.array(TeacherAssignmentSchema).optional(),
    aiCommentary: StudyAiCommentarySchema.optional(),
    readerThoughts: z.string().optional(),
});
/**
 * Check if a working study is complete enough to save
 */
export function isStudyComplete(study) {
    return !!(study.name &&
        study.startingLocation &&
        study.writingLocation &&
        study.studyGroupId &&
        study.scenes &&
        study.scenes.length > 0);
}
//# sourceMappingURL=study.js.map